<template>
  <div>
    <search-form ref="searchForm" :loading="loading" @search="handleSearch"></search-form>

    <el-card v-loading="loading" class="m-t-md">
      <el-button v-if="!isFinance" type="primary" @click="handleCreate">创建工单</el-button>
      <br>
      <br>

      <el-table :data="tableData">
        <el-table-column label="申诉ID" width="80" prop="id"></el-table-column>
        <el-table-column label="工单名称&类型" width="180" show-overflow-tooltip v-slot="{ row }">
          <task-info-mod :data="row"></task-info-mod>
        </el-table-column>
        <el-table-column label="申诉类型" width="80" v-slot="{ row }">
          {{ appealTypeMap[row.applicationType] }}
        </el-table-column>
        <el-table-column label="申诉一级场景" width="100" v-slot="{ row }">
          {{ levelOneAppealMap[row.bussType] }}
        </el-table-column>
        <el-table-column label="申诉二级场景" width="100" v-slot="{ row }">
          {{ levelTwoAppealMap[row.complaintType] }}
        </el-table-column>
        <el-table-column label="申诉状态" align="center" width="120" v-slot="{ row }">
          {{ appealStatusMap[row.reviewStatus] }}
          <el-tooltip v-if="row.reviewStatus === APPEAL_STATUS.REJECT.code" :content="row.refuseReason" placement="top">
            <i class="el-icon-info" style="color:red" />
          </el-tooltip>
        </el-table-column>
        <!-- <el-table-column label="非标清单附件数" width="120" prop="outsideFileListNum"></el-table-column> -->
        <el-table-column label="创建时间" width="140" prop="insertTime" show-overflow-tooltip></el-table-column>
        <el-table-column label="创建人" width="100" prop="name"></el-table-column>
        <el-table-column label="申诉发起时间" width="140" prop="applicationTime" show-overflow-tooltip></el-table-column>
        <el-table-column label="申诉人" width="100" prop="applicationUser"></el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="pagination.current"
        :page-sizes="[20, 50, 100, 1000, 2000]"
        :page-size="pagination.size"
        :total="pagination.total"
        layout="total, sizes, prev, pager, next, jumper"
        class="pagination"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Complaint } from '@/models/Complaint'
import complaintService from '@/api/complaint'
import { paginationTableMixin } from '@/utils/mixins'
import TaskInfoMod from './TaskInfoMod.vue'
import SearchForm from './SearchForm.vue'
import {
  APPEAL_STATUS,
  appealTypeMap,
  levelOneAppealMap,
  levelTwoAppealMap,
  appealStatusMap
} from '../const'

export default {
  name: 'ComplaintList',
  components: {
    SearchForm,
    TaskInfoMod
  },
  mixins: [paginationTableMixin],
  data() {
    return {
      APPEAL_STATUS,
      appealStatusMap,
      appealTypeMap,
      levelOneAppealMap,
      levelTwoAppealMap,
    }
  },
  computed: {
    ...mapGetters([
      'isFinance'
    ])
  },
  methods: {
    async fetchData() {
      this.loading = true
      try {
        const params = this.$refs.searchForm.getParams()
        const resp = await complaintService.find({
          ...params,
          page: this.pagination.current - 1,
          num: this.pagination.size
        })
        this.pagination.total = resp.total
        this.tableData = (resp.list || []).map(row => new Complaint(row))
      } catch (error) {
        this.$alert(`查询失败.${error.message}`, '错误', {
          type: 'error'
        })
      }
      this.loading = false
    },
    handleCreate() {
      this.$router.push({ name: 'appealEdit' })
    }
  }
}
</script>
